module.exports = __webpack_public_path__ + "static/img/new-man-mask.d54043e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-home/new-man-mask.png
// module id = MnR4
// module chunks = 52